import { createAction, props } from '@ngrx/store';

export const GET_CALL_DETAILS_REQUEST = 'GET_CALL_DETAILS_REQUEST';
export const GET_CALL_DETAILS_SUCCESS = 'GET_CALL_DETAILS_SUCCESS';
export const GET_CALL_DETAILS_FAILURE = 'GET_CALL_DETAILS_FAILURE';

export const getCallDetailsRequest = createAction(
  GET_CALL_DETAILS_REQUEST,
  props<{ billingAccountNumber: string; documentId: string }>()
);
export const getCallDetailsSuccess = createAction(
  GET_CALL_DETAILS_SUCCESS,
  props<{ csvResponse: string; entityUrl?: string }>()
);
export const getCallDetailsFailure = createAction(
  GET_CALL_DETAILS_FAILURE,
  props<{ errorCode?: string }>()
);
